function Header(props){
  return (
    <header className={props.className} style={{top: props.top, left: props.left}}>
      <span>
        {props.text}
      </span>
    </header>
  );
}

export default Header;